$('body').on('click', '.change-client-user-management', function () {
    var clientId = $(this).data('client-id');
    var userId = $(this).data('user-id');

    $.ajax({
        type: "POST",
        url: routes['app.client_user.change_management'],
        data: {
            client_id: clientId,
            user_id: userId
        },
        success: function (data) {
            if (currentUserId == userId) {
                $('#user-table').bootstrapTable('refresh')
            }
            if (data.can_manage) {
                var booleanHtml = booleanTrue
            } else {
                var booleanHtml = booleanFalse
            }
            $('.management-boolean[data-user-id=' + userId + '][data-client-id=' + clientId + ']').html(booleanHtml)
        },
        dataType: 'json'
    });
})
